import { RoleCode } from 'corso-types';

export const roleCodeLabel = {
  [RoleCode.corsoAdmin]: 'Corso Admin',
  [RoleCode.admin]: 'Admin',
  [RoleCode.staff]: 'Staff',
  [RoleCode.commerceApiAdmin]: 'Commerce API Admin',
} satisfies Record<RoleCode, string>;

export const roleCodeOptions = Object.values(RoleCode)
  .map((value) => ({
    value,
    label: roleCodeLabel[value],
  }))
  .filter((o) => o.value !== RoleCode.commerceApiAdmin);
